module.exports = __webpack_public_path__ + "img/Microscopy_Base.b40b4f95.png";